import axios from 'axios';

interface CurrencyInfo {
	name: string;
	code: string;
	symbol: string;
}

export async function getCurrencyInfoByCountry(countryName: string): Promise<CurrencyInfo | null> {
	try {
		const response = await axios.get(`https://restcountries.com/v3.1/name/${countryName}`);

		if (response.data && response.data.length > 0) {
			const countryInfo = response.data[0];
			const currency = countryInfo.currencies;

			if (currency) {
				const primaryCurrencyCode = Object.keys(currency)[0];
				const primaryCurrency = currency[primaryCurrencyCode];

				const currencyInfo: CurrencyInfo = {
					name: primaryCurrency.name,
					code: countryInfo?.idd?.root || '',
					symbol: primaryCurrency.symbol,
				};

				return currencyInfo;
			}
		}
	} catch (error) {
		console.error('Error fetching currency information:', error);
	}

	return null;
}
export async function shortenUrl(url: string): Promise<any | null> {
	try {
		const response = await axios.post(
			`https://api.tinyurl.com/create?api_token=hVUu8J4mOexIsirUd89ZKKcn6QE0l19jUhbt1Zn5YLFRP4Y7tBL3ev1riGyJ`,
			{
				url,
				domain: 'tinyurl.com',
				tags: 'example,link',
				description: 'string',
			}
		);

		return response;
	} catch (error) {
		console.error('Error fetching currency information:', error);
	}

	return null;
}
